<header
  class="h-16 w-full max-w-full bg-bluegray-900 border-b border-bluegray-800 shadow-sm flex-shrink-0"
>
  <div
    class="flex items-center justify-between h-full gap-4 px-4 lg:px-6 w-full max-w-full min-w-0"
  >
    <!-- Left Section: Avatar (Mobile) or Breadcrumb (Desktop) -->
    <div class="flex items-center gap-2 overflow-hidden min-w-0 flex-1">
      <!-- Mobile Avatar -->
      <div class="lg:hidden flex-shrink-0">
        <app-user-menu />
      </div>

      <!-- Desktop Breadcrumb -->
      <div class="hidden lg:block min-w-0 overflow-hidden">
        <app-breadcrumb />
      </div>
    </div>

    <!-- Right Section: Actions -->
    <div class="flex items-center gap-4 flex-shrink-0 sm:gap-6">
      <!-- Environment Badge (Desktop Only) -->
      <div class="hidden lg:block">
        <app-environment-badge />
      </div>

      <!-- Novo Lead Action (Desktop) -->
      <div class="hidden lg:block">
        <app-icon-button
          icon="plus"
          label="Novo lead"
          (handleClick)="criarLead()"
          variant="outlined"
          [disable]="!podeCriarLead()"
          styleClass="!border-white/20 !text-white !bg-transparent hover:!bg-white/10 transition-all active:scale-95 !text-sm !font-medium"
        />
      </div>

      <!-- Notifications & User (Desktop) -->
      <div class="hidden lg:flex items-center gap-4 ml-2">
        <app-notificacao-badge></app-notificacao-badge>
        <app-user-menu></app-user-menu>
      </div>

      <!-- Mobile/Tablet Actions -->
      <div class="flex items-center gap-3 lg:hidden">
        <app-notificacao-badge></app-notificacao-badge>

        <app-icon-button
          icon="plus"
          (handleClick)="criarLead()"
          [rounded]="true"
          [severity]="'secondary'"
          variant="text"
          [disable]="!podeCriarLead()"
          styleClass="!text-white hover:!bg-bluegray-800 !w-10 !h-10 !flex !items-center !justify-center"
        />
      </div>
    </div>
  </div>
</header>
